/**
 * @fileoverview React date separator for event feed messages.
 */

import React from 'react';

import { formatMessageDate, getDateObject, MessageDateValue } from 'event-feed/util/dateHelpers';

export interface MessageDateProps {
  date?: MessageDateValue;
}

const MessageDate: React.FC<MessageDateProps> = ({ date = null }) => {
  const dateObject = getDateObject(date);

  return (
    <div className="bl-message_date">
      <div className="bl-message_date_line"></div>
      <div className="bl-message_date_text">
        {dateObject ? (
          <time dateTime={dateObject.toISOString()}>
            {formatMessageDate(dateObject, 'MMMM D, YYYY')}
          </time>
        ) : null}
      </div>
    </div>
  );
};

export default MessageDate;
